<template>
  <div>
    <div class="table">
      <el-form :model="form" label-width="120px" :rules="rules" ref="ruleForm">
        <el-form-item label="主标题" prop="title">
          <el-select v-model="saveData.address" placeholder="请选择" style="width: 100%;">
            <el-option v-for="item in provs" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div class="dialog-Btn">
        <el-button size="small" @click="closedialog">取消</el-button>
        <el-button size="small" type="primary" @click="updateData">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addClassicCase } from "@/api/case.js";
import cityJson from "@/views/components/map.json"
import { createMapOptions } from "@/utils/mapLocale";

export default {
  name: 'title_ecit',
  props: {
    pageObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    closedialog: {
      type: Function,
      default: () => { }
    }
  },
  data() {
    return {
      form: {},
      saveData: {},
      provs: [],
    }
  },
  mounted() {
    this.provs = createMapOptions(cityJson, this.$store.state.language);
    this.saveData = this.$store.state.pageTemplateData
  },
  methods: {
    updateData() {
      addClassicCase(this.saveData).then(res => {
        if (res.code == 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.closedialog()
          this.$store.commit('changeRefresh')
        } else {
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }

      })
    },
  }
}

</script>
<style  lang="scss" scoped>
.dialog-Btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
